import React, { FC, ReactNode } from "react";
import "./style.scss";

interface TitleProps {
  level?: "large" | "1" | "2" | "3" | "4";
  children: ReactNode;
  className?: string;
}

const TextTitle: FC<TitleProps> = ({
  level = "large",
  children,
  className = "",
}) => {
  return <div className={`title-${level} ${className}`}>{children}</div>;
};

export default TextTitle;
